export const THEME_MODE = 'THEME_MODE';
export const LIGHT = 'LIGHT';
export const DARK = 'DARK';